import { parseResponseData, publicAPI } from "@/shared/lib";
import { funnelIntakeSchema } from "../models";

export interface GetFunnelIntakeParams {
  bmi: number;
  sex: string;
  weight?: number;
  goalWeight?: number;
}

export const getFunnelIntake = async (params: GetFunnelIntakeParams) => {
  const response = await publicAPI.post("/onboarding/funnel-intake", params);

  return parseResponseData(response, funnelIntakeSchema);
};
